module.exports = __webpack_public_path__ + "static/DSC_9222-4737de0a4364698928f5b0577f287f04.jpg";